import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Tab/filter/search state in the URL so browser Back restores it. push=true creates a history entry (tabs).
export function useUrlState(key, initial, push = false) {
  const [sp, setSp] = useSearchParams();
  const v = sp.get(key) ?? initial;
  const set = useCallback((nv) => {
    setSp((p) => {
      const n = new URLSearchParams(p);
      const val = typeof nv === "function" ? nv(p.get(key) ?? initial) : nv;
      if (val === initial || val === "" || val == null) n.delete(key); else n.set(key, String(val));
      return n;
    }, { replace: !push });
  }, [key, initial, push, setSp]);
  return [v, set];
}

export function usePersistedState(key, initial) {
  const k = `ti-state:${key}`;
  const [v, setV] = useState(() => {
    try { const s = sessionStorage.getItem(k); return s !== null ? JSON.parse(s) : initial; } catch { return initial; }
  });
  useEffect(() => { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch { /* ignore */ } }, [k, v]);
  return [v, setV];
}

export function useUnsavedGuard(dirty) {
  useEffect(() => {
    window.__tiDirty = !!dirty;
    const h = (e) => { if (dirty) { e.preventDefault(); e.returnValue = ""; } };
    window.addEventListener("beforeunload", h);
    return () => { window.__tiDirty = false; window.removeEventListener("beforeunload", h); };
  }, [dirty]);
}

export function confirmLeave() {
  return !window.__tiDirty || window.confirm("Ada perubahan yang belum disimpan. Tetap keluar dari halaman ini?");
}
